<template>
    <div>
        <el-tabs v-model="activeName"  type="border-card">
            <el-tab-pane label="访谈邀请(内部)" name="0">
                <cooperativeForm :sectionClassId="12"></cooperativeForm>
            </el-tab-pane>
            <el-tab-pane label="访谈邀请(消费者)" name="1">
                <cooperativeForm :sectionClassId="13"></cooperativeForm>
            </el-tab-pane>
            <el-tab-pane label="邀请我" name="2">
                <interviewInviteCall :sectionClassId="'12,13'"></interviewInviteCall>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import cooperativeForm from '@/components/cooperative/cooperativeForm'
    import interviewInviteCall from '@/components/cooperative/interviewInviteCall'

    //定义组件
    export default {
        data() {
            return {
                activeName:'0',
            }
        },
        components:{
            cooperativeForm,interviewInviteCall
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/cooperative/interviewinvitation.vue